import { render, staticRenderFns } from "./AInvoicesTab.vue?vue&type=template&id=0f02d6d7&"
import script from "./AInvoicesTab.vue?vue&type=script&lang=js&"
export * from "./AInvoicesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports